/* global swal */

import './style.less';

export default function($log, $state, $stateParams, $scope, Swal, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  const { company_id, profile_uid } = ProfileClass.profileComplete.profile;
  const courseId = $stateParams.courseId;
  vm.resultsQueried = false;
  vm.selectedAdmins = {};

  // dictionary to display names without hyphens
  vm.displayDict = {
    'course-info': 'Course Info',
    'modules-info': 'Modules',
    'event-materials': 'Event Materials',
    'final-questions': 'Final Questions'
  };
  // if the course is NOT being reviewed load the admins for the author to pick from
  // TODO: CompanyClass Should also be move into the activation function
  if (!vm.reviewOnly) {
    ApiClass.scan(
      ApiClass.usersGet,
      {},
      {},
      {
        queryParams: {
          manage: true,
          'scan:limit': 10000,
          'filter:admins': true
        }
      }
    )
      .then(({ items: profiles }) => {
        vm.admins = profiles;
      })
      .catch($log.error);
  }

  vm.submitCourse = () => {
    const profiles = Object.keys(vm.selectedAdmins).filter(key => vm.selectedAdmins[key]);

    if (!profiles.length) return swal('Not Submitted', 'Please select an Admin to review your course.', 'info');

    vm.submitBtn = true;

    vm.action()
      .then(() => {
        const course = {
          adminReview: true,
          course_id: courseId,
          lastSubmittedForReviewBy: profile_uid,
          reviewAdmins: profiles,
          submitted: true
        };
        return ApiClass.coursesIdPatch({ id: courseId, manage: true }, { course });
      })
      .then(() => {
        vm.reviewOnly = true;
        vm.submitBtn = false;
        $state.go('app.author.courses', $stateParams);
      })
      .catch(error => {
        vm.submitBtn = false;
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    vm.loaded = false;
    vm.error = {};

    vm.ngModel.form_id = vm.ngModel.form_id || 'NASBA_Live';
    vm.vendorDict = vm.vendors.obj;
    vm.payee = vm.payees.obj;

    if (vm.ngModel.adminReview) vm.reviewOnly = true;

    ApiClass.companiesIdTypeTypeIdGet(
      { manage: false, id: company_id, type: 'evaluationForms', type_id: vm.ngModel.form_id },
      null
    )
      .then(({ data: { item } }) => {
        vm.reviewForm = item;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/author/submitForReview/controller.js